import {
	Icon,
	IconButton,
	LinearProgress,
	Paper,
	Popover,
	Table,
	TableBody,
	TableCell,
	TableRow,
	Typography
} from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import EnhancedTableHead from 'components/EnhancedTableHead/EnhancedTableHead.jsx';
import EmptyBody from 'components/Table/EmptyBody.jsx';
import {
	GetUserId,
	GetUserKey,
	GetUserToken,
	Logout
} from 'helpers/UserHelper';
import { GetQuoteHistory } from 'queries/quotes/queries';
import React from 'react';
import { Query, Mutation } from 'react-apollo';
import { Redirect } from 'react-router';
import CustomChip from 'components/CustomChip/CustomChip.jsx';
import { QuoteEligibility } from 'queries/QuoteEligibility';
import Grid from '@material-ui/core/Grid';
import SweetAlert from 'react-bootstrap-sweetalert';
import sweetAlertStyle from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx';
import withStyles from '@material-ui/core/styles/withStyles';

const columnData = [
	{
		id: 'edit',
		numeric: false,
		disablePadding: true,
		label: '',
		noSort: true,
		width: '30px'
	},
	{
		id: 'description',
		numeric: false,
		disablePadding: true,
		label: 'Description',
		noSort: true
	},
	{
		id: 't.date_created',
		numeric: false,
		disablePadding: true,
		label: 'Date Created',
		noSort: true
	}
];

class QuotesTab extends React.Component {
	state = {
		openMenus: [],
		openMenusPage: 0,
		anchorTop: 0,
		anchorLeft: 0,
		popoverOpen: false,
		assistantActive: false,
		eligibilityDialogOpen: false,
		invalidFields: [],
		selectedClient: {}
	};

	handleClick = (event, id) => {
		this.setState({ anchorTop: event.clientY, anchorLeft: event.clientX });

		var openMenus = this.state.openMenus.slice();
		openMenus.filter(x => x.id === id)[0].open = true;
		this.setState({ openMenus: openMenus, popoverOpen: true });
	};

	handleClose = id => {
		var openMenus = this.state.openMenus.slice();
		openMenus.filter(x => x.id === id)[0].open = false;
		this.setState({ openMenus: openMenus, popoverOpen: false });
	};

	handleCloseAll = () => {
		var openMenus = this.state.openMenus.slice();
		openMenus = openMenus.map(x => x.open === false);
		this.setState({ openMenus: openMenus, popoverOpen: false });
	};

	handleView(quote) {
		this.props.history.push({
			pathname: '/app/quoteresult',
			search: `guid=${quote.sq_taskguid}`
		});
	}

	handleEdit(clientId, guid) {
		this.props.history.push({
			pathname: '/app/quote/',
			search: `clientId=${clientId}&guid=${guid}`
		});
	}

	checkAssistantActive() {
		if (GetUserKey('userType') === '6') {
			if (!this.state.assistantActive) {
				this.setState({ assistantActive: true });
			}
			return true;
		}
		return false;
	}

	getBrokerId = () => {
		let brokerId = GetUserId();
		if (this.checkAssistantActive()) {
			brokerId = sessionStorage.getItem('ActiveBrokerId');
		}
		return brokerId;
	};

	getBrokerName = () => {
		return sessionStorage.getItem('ActiveBrokerName');
	};

	handleNewQuote = clientId => {
		this.props.history.push({
			pathname: '/app/quote/',
			search: `clientId=${clientId}`
		});
	};

	render() {
		const colSpan = Object.keys(columnData).length;
		const { clientId, clientName } = this.props;

		return (
			<Query
				query={GetQuoteHistory}
				variables={{
					brokerId: this.getBrokerId(),
					token: GetUserToken(),
					limit: 7,
					page: 0,
					clientId: clientId
				}}
				fetchPolicy="network-only"
			>
				{({ loading, error, data, refetch }) => {
					if (loading) {
						return <LinearProgress />;
					}
					if (
						error &&
						error.message &&
						error.message === 'GraphQL error: invalid token'
					) {
						Logout();
						return <Redirect to="/app/portal/login" />;
					}

					if (error) return `Error! ${error.message}`;

					const items = data.QuoteHistory.Results;

					if (items && this.state.openMenus.length !== items.length) {
						let openMenus = [];

						items.map(q => {
							openMenus.push({
								open: false,
								id: q.sq_taskguid
							});

							return q;
						});

						this.setState({
							openMenus: openMenus
						});
					}

					return (
						<React.Fragment>
							<Mutation
								mutation={QuoteEligibility}
								onCompleted={data => {
									var quoteEligibility = data.QuoteEligibility;
									if (!quoteEligibility.valid) {
										let invalidFields = quoteEligibility.invalidFields.split(
											','
										);
										this.setState({
											eligibilityDialogOpen: true,
											invalidFields: invalidFields,
											selectedClient: this.props.clientName
										});
									} else {
										this.handleNewQuote(clientId);
									}
								}}
							>
								{mutate => (
									<CustomChip
										text="Create Quote"
										icon="add"
										clicked={() =>
											mutate({
												variables: {
													input: {
														clientId: clientId
													}
												}
											})
										}
										style={{ margin: '25px auto 15px auto' }}
									/>
								)}
							</Mutation>

							<Paper style={{ overflowX: 'auto' }}>
								<Table>
									<EnhancedTableHead
										order={this.props.order}
										orderBy={this.props.orderBy}
										onRequestSort={(event, property) =>
											this.props.handleRequestSort(event, property)
										}
										rowCount={this.props.items ? this.props.items.length : 0}
										columnData={columnData}
									/>
									<TableBody>
										{' '}
										<React.Fragment>
											{items.length < 1 ? (
												<EmptyBody
													colSpan={colSpan}
													rowSpan={3}
													placeHolder={
														<Typography variant="subheading">
															No Quotes created yet. Click on Create Quote
														</Typography>
													}
												/>
											) : (
												<React.Fragment>
													{items.map(quote => {
														var openMenus = this.state.openMenus.length > 0;
														var openMenu = null;

														if (openMenus) {
															openMenu = this.state.openMenus.find(
																m => m.id === quote.sq_taskguid
															);
														}

														return (
															<TableRow
																className="sqDataTable"
																key={quote.id}
																onClick={e =>
																	this.state.popoverOpen === false
																		? this.handleClick(e, quote.sq_taskguid)
																		: null
																}
																style={
																	openMenu && openMenu.open
																		? { backgroundColor: '#dedede' }
																		: {}
																}
															>
																<TableCell
																	style={{
																		padding: '0px',
																		borderRight: '1px solid #e0e0e0',
																		backgroundColor: 'white'
																	}}
																>
																	<IconButton
																		onClick={e =>
																			this.state.popoverOpen === false
																				? this.handleClick(e, quote.sq_taskguid)
																				: null
																		}
																	>
																		<Icon>more_vert</Icon>
																	</IconButton>
																</TableCell>
																<TableCell>{quote.description}</TableCell>
																<TableCell>{quote.date_created}</TableCell>
																<Popover
																	open={openMenu ? openMenu.open : false}
																	anchorReference="anchorPosition"
																	anchorPosition={{
																		left: this.state.anchorLeft,
																		top: this.state.anchorTop
																	}}
																	onClose={() =>
																		this.handleClose(quote.sq_taskguid)
																	}
																>
																	<List component="nav">
																		<ListItem
																			button
																			onClick={() => this.handleView(quote)}
																		>
																			<ListItemText primary="View Results" />
																		</ListItem>
																		<Divider />
																		<Mutation
																			mutation={QuoteEligibility}
																			onCompleted={data => {
																				var quoteEligibility =
																					data.QuoteEligibility;
																				if (!quoteEligibility.valid) {
																					let invalidFields = quoteEligibility.invalidFields.split(
																						','
																					);
																					this.setState({
																						eligibilityDialogOpen: true,
																						invalidFields: invalidFields,
																						selectedClient: quote.fullName
																					});
																				} else {
																					this.handleEdit(
																						quote.fk_clientID,
																						quote.sq_taskguid
																					);
																				}
																			}}
																		>
																			{mutate => (
																				<ListItem
																					button
																					divider
																					onClick={() =>
																						mutate({
																							variables: {
																								input: {
																									clientId: quote.fk_clientID
																								}
																							}
																						})
																					}
																				>
																					<ListItemText primary="Edit Quote" />
																				</ListItem>
																			)}
																		</Mutation>
																	</List>
																</Popover>
															</TableRow>
														);
													})}
												</React.Fragment>
											)}
										</React.Fragment>
									</TableBody>
								</Table>
							</Paper>

							<Typography
								variant="subheading"
								style={{
									color: '#0000008a',
									marginTop: '15px'
								}}
								className="typographyLinkBasic"
								onClick={() => {
									this.props.history.push({
										pathname: '/app/history',
										search: `clientId=${clientId}&clientName=${clientName}`
									});
								}}
							>
								View all Quotes
							</Typography>
							{this.state.eligibilityDialogOpen ? (
								<SweetAlert
									warning
									style={{ wordWrap: 'break-word', top: '40%' }}
									title={'Ineligible'}
									confirmBtnCssClass={
										this.props.classes.button + ' ' + this.props.classes.success
									}
									cancelBtnCssClass={
										this.props.classes.button + ' ' + this.props.classes.danger
									}
									confirmBtnText="Edit Client"
									cancelBtnText="Close"
									onConfirm={() => {
										this.handleEditClient();
									}}
									onCancel={() => {
										this.setState({
											eligibilityDialogOpen: false
										});
									}}
									showCancel={!this.state.loadingDelete}
									showConfirm={!this.state.loadingDelete}
								>
									<Typography>
										{this.state.selectedClient}
										is ineligible for a quote.
									</Typography>
									<br />
									<Typography>Please update the following fields: </Typography>
									<Grid container className="invalidListBlock">
										{this.state.invalidFields.map(i => {
											return (
												<Grid item xs={12} sm={6} md={6}>
													<Typography>{i}</Typography>
												</Grid>
											);
										})}
									</Grid>
								</SweetAlert>
							) : null}
						</React.Fragment>
					);
				}}
			</Query>
		);
	}
}

export default withStyles(sweetAlertStyle)(QuotesTab);



// WEBPACK FOOTER //
// ./src/views/Clients/ClientDetail/tabs/quotes/QuotesTab.jsx